import lng from '@lightningjs/core';
import { Router, Storage } from '@lightningjs/sdk';
import { Colors, Utils } from '@lightningjs/sdk';
import { setProfileFilter } from '../../../../api/profiles';
import { store } from '../../../../utils/globalData';
export default class FilterContent extends lng.Component {
  static _template() {
    return {
      w: 800,
      h: 50,
      collision: true,
      ContentItem: {
        texture: lng.Tools.getRoundRect(
          50,
          50,
          1,
          4,
          Colors('#ffffff').get(),
          true,
          Colors('#000000').get()
        ),
      },
      Icon: {},
      ContentTitle: {},
      FilterBorder: {},
    };
  }
  set filterLink(val) {
    return (this._filterLink = val);
  }
  get filterLink() {
    return this._filterLink;
  }
  get _Icon() {
    return this.tag('Icon');
  }
  get _ContentTitle() {
    return this.tag('ContentTitle');
  }
  get _FilterBorder() {
    return this.tag('FilterBorder');
  }
  get _ContentItem() {
    return this.tag('ContentItem');
  }

  set index(val) {
    this._index = val;
  }

  _init() {
    this._isSelected = false;
    this._selectedItems = null;
  }
  _deselectOption() {
    this._Icon.patch({ texture: null });
    this._ContentTitle.patch({ color: Colors('#D6D6D6').get() });
    this._isSelected = false;
    let filterOptions = Storage.get('FilterOptions') || [];
    // Step 2: Modify the object
    const optionIndex = filterOptions.findIndex((o) => o.name === this._filterLink.name);
    if (optionIndex !== -1) {
      // Modify the object as needed
      filterOptions[optionIndex].checked = false;
    }
    // Step 3: Save the updated object back to storage
    Storage.set('FilterOptions', filterOptions);
  }

  _handleEnter() {
    store.clearData();
    this._checkOptions();
  }
  _firstEnable() {
    const name = this._filterLink.name;
    const checked = this._filterLink.checked;
    let filterOptions = Storage.get('FilterOptions') || [];
    const existingOption = filterOptions.find((option) => option.name === name);
    // If option doesn't exist in local storage, add it. Otherwise, do nothing.
    if (!existingOption) {
      filterOptions.push({ name: name, checked: checked });
      Storage.set('FilterOptions', filterOptions);
    }
    if (this._filterLink.checked) {
      this._Icon.patch({
        x: 762,
        y: 13,
        texture: lng.Tools.getSvgTexture(
          Utils.asset('images/settings-icons/checkmark.svg'),
          30,
          30
        ),
      });
      this._ContentTitle.patch({ color: Colors('#FAFAFA').get() });
      this._isSelected = true;
    } else {
      this._Icon.patch({ texture: null });
      this._ContentTitle.patch({ color: Colors('#D6D6D6').get() });
      this._isSelected = false;
    }
    this._ContentItem.patch({
      x: 750,
      texture: lng.Tools.getRoundRect(
        50,
        50,
        1,
        4,
        Colors('#F2F2F2').get(),
        true,
        Colors('#000000').get()
      ),
    });
    this._ContentTitle.patch({
      x: 40,
      y: 5,
      text: {
        text: this._filterLink.title,
        fontSize: 36,
        fontFace: 'OpenSans-Regular',
      },
      color: Colors('#D6D6D6').get(),
    });
  }
  _focus() {
    super._focus();
    if (!this._isSelected) {
      this._ContentTitle.patch({
        color: Colors('#FAFAFA').get(),
      });
    }
    this._ContentItem.patch({
      x: 750,
      texture: lng.Tools.getRoundRect(
        50,
        50,
        1,
        4,
        Colors('#02AC25').get(),
        true,
        Colors('#000000').get()
      ),
    });
  }
  _unfocus() {
    super._unfocus();
    if (!this._isSelected) {
      this._ContentTitle.patch({
        color: Colors('#D6D6D6').get(),
      });
    }
    this._ContentItem.patch({
      x: 750,
      texture: lng.Tools.getRoundRect(
        50,
        50,
        1,
        4,
        Colors('#FFFFFF').get(),
        true,
        Colors('#000000').get()
      ),
    });
  }

  _handleBack() {
    let filterOptions = Storage.get('FilterOptions');
    const options = {};
    if (filterOptions && Array.isArray(filterOptions)) {
      filterOptions.forEach((filter) => {
        options[filter.name] = filter.checked;
      });
    }
    setProfileFilter(options).then((res) => {
      let routerPath = Router.getHistory();
      let lasRouterPath = routerPath[routerPath.length - 1].hash;
      if (lasRouterPath.includes('categories')) {
        Router.replaceHistoryState({ hash: 'browse' });
        Router.navigate('browse');
      } else {
        Router.back();
      }
      Storage.remove('FilterOptions');
    });
  }

  _checkOptions() {
    let filterOptions = Storage.get('FilterOptions') || [];
    const option = filterOptions.find((o) => o.name === this._filterLink.name);

    if (option) option.checked = true;
    // Automatically deselect the other profiles, but only if the current profile is 'kids' or 'parent'
    if (this._isSelected) {
      this._Icon.patch({ texture: null });
      this._ContentTitle.patch({ color: Colors('#D6D6D6').get() });
      this._isSelected = false;
      if (option) option.checked = false;
      Storage.set('FilterOptions', filterOptions);
    } else {
      this._Icon.patch({
        x: 762,
        y: 13,
        texture: lng.Tools.getSvgTexture(
          Utils.asset('images/settings-icons/checkmark.svg'),
          30,
          30
        ),
      });
      this._ContentTitle.patch({ color: Colors('#FAFAFA').get() });
      this._isSelected = true;
      Storage.set('FilterOptions', filterOptions);
      if (
        (this._filterLink.id === 0 || this._filterLink.id === 1) &&
        this.parent.__childList._items
      ) {
        this.parent.__childList._items.forEach((item) => {
          if (item !== this && (item._filterLink.id === 0 || item._filterLink.id === 1)) {
            item._deselectOption();
          }
        });
      }
      if (
        (this._filterLink.id === 2 || this._filterLink.id === 3) &&
        this.parent.__childList._items
      ) {
        this.parent.__childList._items.forEach((item) => {
          if (item !== this && (item._filterLink.id === 2 || item._filterLink.id === 3)) {
            item._deselectOption();
          }
        });
      }
    }
  }

  // Magic Remote

  _handleHover() {
    this.fireAncestors('$setIndex', this._index);
    this._focus();
  }

  _handleUnhover() {
    this._unfocus();
  }

  _handleClick() {
    this._checkOptions();
  }
}
